import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import SlsRtnIndexActions, { SlsRtnIndexTypes } from '../Stores/SlsRtnIndex/Actions';

const getAppStore = state => state.app;

export function* slsRtnIndexFetchSlsRtnIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(SlsRtnIndexActions.slsRtnIndexFetchSlsRtnIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `slsRtn/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        SlsRtnIndexActions.slsRtnIndexFetchSlsRtnIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(SlsRtnIndexActions.slsRtnIndexFetchSlsRtnIndexLoading(false));
  }
}

export function* slsRtnIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/slsRtnDetail/update/${hdrId}`));
}

export function* slsRtnIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/SLS_RTN/${hdrId}/SlsRtnHdr`));
}

export function* slsRtnIndexResetSlsRtnFServ02({ hdrIds }) {
  try {
    yield put(SlsRtnIndexActions.slsRtnIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `slsRtn/fServProcess/RESET_SLS_RTN_F_SERV_02/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(SlsRtnIndexActions.slsRtnIndexResetSlsRtnFServ02Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(SlsRtnIndexActions.slsRtnIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(SlsRtnIndexTypes.SLS_RTN_INDEX_FETCH_SLS_RTN_INDEX, slsRtnIndexFetchSlsRtnIndex),
  takeLatest(SlsRtnIndexTypes.SLS_RTN_INDEX_GO_TO_DOCUMENT, slsRtnIndexGoToDocument),
  takeLatest(SlsRtnIndexTypes.SLS_RTN_INDEX_GO_TO_AUDIT, slsRtnIndexGoToAudit),
  takeLatest(SlsRtnIndexTypes.SLS_RTN_INDEX_RESET_SLS_RTN_F_SERV02, slsRtnIndexResetSlsRtnFServ02)
];
